/* eslint-disable no-undef */

<template>
  <section
    class="section mt-80 section-primary is-medium animated preFadeInUp fadeInUp"
  >
    <!-- comment -->
    <div class="container">
      <SoonModal :active="visaSoonModal" @close="visaSoonModal = false" />

      <div
        id="success-overlay"
        class="modal modal-lg modal-success"
        v-bind:class="{
          //'is-active': true,
          //'is-active': userDataActiveModal,
          // 'is-active': false,
          // 'is-active': !IsAgreeOnTerms && IsAgreeOnTerms != null,
          'is-active':
            IsAgreeOnTerms &&
            !userData.IsKycReviewed &&
            userData.IsKycReviewed != null &&
            userDataActiveModal,
        }"
      >
        <div class="modal-background scaleInCircle"></div>
        <div class="modal-content scaleIn" style="position: fixed; top: 20px">
          <div class="flex-card simple-shadow" style="margin: 0px">
            <header class="modal-card-head">
              <p class="modal-card-title p-20">
                <b>معلومات المستخدم الشخصية</b>
              </p>
            </header>
            <div
              class="card-body"
              style="padding-right: 0px; padding-left: 0px; padding-top: 0px"
            >
              <div class="content">
                <section
                  class="modal-card-body"
                  style="padding-right: 40px; padding-left: 40px"
                >
                  <div class="animated preFadeInUp fadeInUp">
                    <div>
                      الرجاء إستكمال البيانات التالية قبل التسجيل في منظومة مصرف
                      ليبيا المركزي لغرض شحن بطاقة الأغراض الشخصية
                    </div>
                    <div>
                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label="رقم جواز السفر"
                            :type="{ 'is-danger': errors.has('passportNo') }"
                            :message="errors.first('passportNo')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.passportNo"
                              name="passportNo"
                              v-validate="'required'"
                              placeholder="ادخل رقم جواز السفر"
                              :disabled="disableFields"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <v-date-picker
                            v-model="
                              requestInfoBasicData.passportExpirationDate
                            "
                            locale="ar"
                            :popover="{
                              placement: 'bottom',
                              visibility: 'click',
                            }"
                            :first-day-of-week="1"
                          >
                            <b-field
                              label="تاريخ انتهاء صلاحية جواز السفر "
                              size="is-medium"
                              :class="{
                                'is-danger': errors.has(
                                  'passportExpirationDate'
                                ),
                              }"
                            >
                              <b-input
                                type="text"
                                class="is-medium has-background-white"
                                :value="
                                  $root.dateformat(
                                    requestInfoBasicData.passportExpirationDate
                                  )
                                "
                                v-validate="'required'"
                                placeholder="تاريخ انتهاء صلاحية جواز السفر "
                                name="passportExpirationDate"
                                :disabled="disableFields"
                                readonly
                                expanded
                              ></b-input>
                            </b-field>
                          </v-date-picker>
                          <span
                            v-show="errors.has('passportExpirationDate')"
                            class="help is-danger is-centered"
                            >{{ errors.first("passportExpirationDate") }}</span
                          >
                        </div>
                      </div>
                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label="الإسم الأول"
                            :type="{ 'is-danger': errors.has('firstName') }"
                            :message="errors.first('firstName')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.firstName"
                              name="firstName"
                              v-validate="'required'"
                              placeholder="ادخل الإسم الأول"
                              expanded
                              :disabled="disableFields"
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label="إسم الأب"
                            :type="{ 'is-danger': errors.has('fatherName') }"
                            :message="errors.first('fatherName')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.fatherName"
                              name="fatherName"
                              v-validate="'required'"
                              placeholder="ادخل إسم الأب"
                              :disabled="disableFields"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                      </div>
                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label="إسم الجد"
                            :type="{
                              'is-danger': errors.has('grandFatherName'),
                            }"
                            :message="errors.first('grandFatherName')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.grandFatherName"
                              name="grandFatherName"
                              v-validate="'required'"
                              placeholder="ادخل إسم الجد"
                              :disabled="disableFields"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>

                        <div class="column is-6">
                          <b-field
                            label="إسم العائلة"
                            :type="{ 'is-danger': errors.has('familyName') }"
                            :message="errors.first('familyName')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.familyName"
                              name="familyName"
                              v-validate="'required'"
                              placeholder="ادخل إسم العائلة"
                              :disabled="disableFields"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                      </div>
                      <div class="columns">
                        <div class="column is-6">
                          <b-field
                            label="الرقم الوطني"
                            :type="{ 'is-danger': errors.has('nid') }"
                            :message="errors.first('nid')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.nid"
                              name="nid"
                              v-validate="{
                                required: true,
                                numeric: true,
                                max: 12,
                                min: 12,
                              }"
                              placeholder="ادخل الرقم الوطني"
                              :disabled="disableFields"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                        <div class="column is-6">
                          <b-field
                            label="رقم الموبايل المربوط بالرقم الوطني "
                            :type="{ 'is-danger': errors.has('nidMobileNo') }"
                            :message="errors.first('nidMobileNo')"
                          >
                            <b-input
                              type="text"
                              size="is-medium"
                              custom-class="has-text-centerd"
                              v-model="requestInfoBasicData.nidMobileNo"
                              name="nidMobileNo"
                              v-validate="{
                                required: true,
                                numeric: true,
                                regex: /^09\d{8}$/,
                              }"
                              placeholder="ادخل رقم الموبايل"
                              :disabled="disableFields"
                              expanded
                            ></b-input>
                          </b-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-20" v-if="userData != null">
                    <a
                      class="button danger-btn btn-align modal-dismiss is-bold is-medium"
                      style="margin-left: 10px; margin-right: 10px"
                      :disabled="disableUpdateBtn"
                      @click="updateBasicData"
                    >
                      <b> تعديل المعلومات الشخصية</b>
                    </a>
                    <span v-if="disableUpdateBtn">
                      <a
                        class="button secondary-btn btn-align modal-dismiss is-bold is-medium"
                        style="margin-left: 10px; margin-right: 10px"
                        @click="validateBeforeSubmit"
                      >
                        <b>أوافق على المعلومات الشخصية</b>
                      </a>
                    </span>
                    <span v-if="!disableUpdateBtn">
                      <a
                        class="button secondary-btn btn-align modal-dismiss is-bold is-medium"
                        style="margin-left: 10px; margin-right: 10px"
                        :disabled="disableUpdateBtn"
                        @click="validateBeforeSubmitKyc"
                      >
                        <b>أوافق على المعلومات الشخصية</b>
                      </a>
                    </span>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
        <!-- <button class="modal-close is-large"></button> -->
      </div>

      <div
        id="success-overlay"
        class="modal modal-lg modal-success"
        v-bind:class="{
          'is-active': alertBox,
        }"
      >
        <div class="modal-background scaleInCircle"></div>
        <div class="modal-content scaleIn" style="position: fixed; top: 20px">
          <div class="flex-card simple-shadow">
            <header class="modal-card-head">
              <p class="modal-card-title p-20">
                <b>تنبيه !</b>
              </p>
            </header>
            <div class="card-body">
              <div class="content">
                <section class="modal-card-body" style="padding: 35px">
                  <div class="animated preFadeInUp fadeInUp">
                    <div>
                      تم تأكيد البيانات, بالامكان التسجيل والشحن في منظومة مصرف
                      ليبيا المركزي
                    </div>
                  </div>
                </section>
              </div>
              <div class="mt-20">
                <a
                  class="button danger-btn btn-align modal-dismiss is-bold is-medium"
                  style="margin: 10px"
                  @click="alertBoxFunc"
                >
                  <b> موافق</b>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- <button class="modal-close is-large"></button> -->
      </div>
      <div
        id="success-overlay"
        class="modal modal-md modal-success"
        style="
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          height: 100%;
          width: 100%;
        "
        v-bind:class="{
          //'is-active': true,
          'is-active': popupStatus && allTerms != null,
        }"
      >
        <div class="modal-background scaleInCircle"></div>
        <div class="modal-content scaleIn">
          <div class="flex-card simple-shadow">
            <header class="modal-card-head">
              <p class="modal-card-title p-20"><b> الشروط و الاحكام </b></p>
            </header>
            <div
              class="card-body"
              style="padding-right: 0px; padding-left: 0px; padding-top: 0px"
            >
              <div class="content">
                <!-- {{ allTerms }} -->
                <section class="modal-card-body" style="padding: 0px">
                  <div class="mt-5 mb-10">
                    <ul v-if="allTerms" style="list-style-type: none">
                      <li
                        v-for="term in allTerms"
                        :key="term"
                        class="has-text-right is-black is-size-6 has-text-justified"
                      >
                        {{ term }}
                      </li>
                    </ul>
                    <loading
                      v-else
                      line-fg-color="#2d3f51"
                      size="large"
                      class="margin-100"
                      spacing="2"
                      text-fg-color="#fff"
                      message="الرجاء الإنتظار"
                    />
                  </div>
                </section>
              </div>
              <div class="mt-20" v-if="allTerms">
                <a
                  class="button secondary-btn btn-align modal-dismiss is-bold is-medium"
                  @click="agreeOnAllTerms"
                >
                  <b>أوفق علي الشروط و الاحكام </b>
                </a>
              </div>

              <div class="mt-20">
                <a
                  class="button danger-btn btn-align modal-dismiss is-bold is-medium"
                  @click="closeTermsModal"
                >
                  <b> اغلاق </b>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- <button class="modal-close is-large"></button> -->
      </div>
      <!-- Title -->
      <p
        class="title has-text-right has-text-white has-text-weight-bold is-4 is-marginless is-paddingless"
      >
        مرحباً,
        <b>{{ user[0] }}</b>
      </p>

      <div
        class="content-wrapper animated preFadeInUp fadeInUp"
        v-if="requestloading"
      >
        <div class="columns is-centered has-text-centered">
          <loading
            line-fg-color="#2d3f51"
            size="massive"
            class="margin-100"
            spacing="55"
            text-fg-color="#fff"
            message="الرجاء الإنتظار"
          />
        </div>
      </div>
      <div class="content-wrapper animated preFadeInUp fadeInUp" v-else>
        <div class="columns is-vcentered">
          <div class="column">
            <!-- <router-link to="to"> -->
            <router-link to="/services/account">
              <div
                class="flex-card icon-card-hover wallet-card light-bordered raised padding-20"
              >
                <h3 class="card-title is-clean">خدمات الحساب</h3>
                <p class="card-description">
                  يمكنك من خلالها الاطلاع على رصيدك و كشف حسابك وغيرها من
                  الخدمات.
                </p>
              </div>
            </router-link>
            <!-- </router-link> -->
          </div>
          <div class="column">
            <router-link to="/services/financial">
              <div
                class="flex-card icon-card-hover cash-card light-bordered padding-20"
              >
                <h3 class="card-title is-clean">خدمات مالية</h3>
                <p class="card-description">تتعلق هذه الخدمات بتحويل الأموال</p>
              </div>
            </router-link>
          </div>

          <div class="column">
            <span @click="checkAgreeTerms('ZAD', 'alzaad')">
              <div
                class="flex-card icon-card-hover alzaad-card light-bordered padding-20"
              >
                <h3 class="card-title is-clean">
                  خدمات البطاقات المحلية (تجوال)
                </h3>
                <p class="card-description">
                  لطلبات إصدار بطاقة ، تغيير حالة بطاقتك (إيقاف/إلغاء) ، إعادة
                  إصدار رقم سري.
                </p>
              </div>
              <!-- </router-link> -->
            </span>
          </div>
        </div>

        <div class="columns is-vcentered">
          <div class="column is-4">
            <!-- <span @click="visaSoonModal = true"> -->
            <span @click="checkAgreeTerms('VISA', 'visa')">
              <div
                class="flex-card icon-card-hover visa-card light-bordered padding-20"
              >
                <h3 class="card-title">
                  خدمات البطاقات الدولية (فيزا , ماستر كارد)
                </h3>
                <p class="card-description">
                  لطلبات إصدار بطاقة ، تغيير حالة بطاقتك (إيقاف/إلغاء) ، إعادة
                  إصدار رقم سري،.
                </p>
              </div>
            </span>
            <!-- <a @click="gotovisaportal()">
              <div
                class="flex-card icon-card-hover visa-card light-bordered padding-20"
              >
                <h3 class="card-title">خدمات البطاقة الدولية (فيزا)</h3>
                <p class="card-description">
                  لطلبات إصدار بطاقة ، تغيير حالة بطاقتك (إيقاف/إلغاء) ، إعادة
                  إصدار رقم سري،.
                </p>
              </div>
            </a> -->
          </div>

          <div class="column is-4">
            <router-link
              :to="
                services.results[7].status
                  ? 'services/refund'
                  : 'services/closed'
              "
            >
              <div
                class="flex-card icon-card-hover first-card light-bordered padding-20"
              >
                <h3 class="card-title">خدمات إعادة المطالبة</h3>
                <p class="card-description">
                  يمكنك من خلالها التقدم بطلب استرجاع مبالغ مخصومة نتيجة حركات
                  (شراء/سحب) غير ناجحة.
                </p>
              </div>
            </router-link>
          </div>

          <!-- <div class="column">
            <span @click="checkAgreeTerms('WAHDAMOBILE', 'mobile')">
              <div
                class="flex-card icon-card-hover second-card light-bordered padding-20"
              >
                <h3 class="card-title is-clean">خدمات الهاتف النقال</h3>
                <p class="card-description">
                  تمكنك من الاشتراك في خدمة الصحارى موبايل (خدمات مصرف الصحارى عبر
                  الهاتف المحمول).
                </p>
              </div>
            </span>
          </div>
          <div class="column">
            <span @click="checkAgreeTerms('WAHDAMOBILE', 'mobicash')">
              <div
                class="flex-card icon-card-hover mobicash-card light-bordered padding-20"
              >
                <h3 class="card-title is-clean">خدمات الموبي كاش</h3>
                <p class="card-description">
                  تمكنك من الاشتراك بخدمة الشراء عن طريق الهاتف النقال (موبي
                  كاش).
                </p>
              </div>
            </span>
          </div> -->
        </div>

        <div class="columns is-vcentered"></div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import arabic from "vee-validate/dist/locale/ar";
import SoonModal from "../components/SoonModal.vue";

export default {
  name: "portal",
  components: { SoonModal },
  data() {
    return {
      visaSoonModal: false,
      user: null,
      services: {},
      requestloading: true,
      IsAgreeOnTerms: null,
      userDataActiveModal: false,
      userData: null,
      disableFields: true,
      disableUpdateBtn: false,
      alertBox: false,
      requestInfoBasicData: {
        id: null,
        firstName: null,
        fatherName: null,
        grandFatherName: null,
        familyName: null,
        passportNo: null,
        nID: null,
        // DOB: null,
        nidMobileNo: null,
        passportExpirationDate: null,
      },
      token: null,
      terms: null,
      requestInfo: null,
      isAgreeOnZadTerms: null,
      isAgreeOnVisaTerms: null,
      isAgreeOnWahdaMobileTerms: null,
      allTerms: null,
      popupStatus: false,
      termName: null,
      termRouterName: null,
    };
  },
  created() {
    moment.locale("en");
    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        firstName: "الإسم الأول",
        fatherName: "إسم الأب",
        grandFatherName: "إسم الجد",
        familyName: "إسم العائلة",
        passportNo: "رقم جواز السفر",
        nid: "الرقم الوطني",
        // DOB: "تاريخ الميلاد",
        nidMobileNo: "رقم الموبايل",
        passportExpirationDate: "تاريخ انتهاء صلاحية جواز السفر",
      },
      custom: {
        nidMobileNo: {
          regex: "رقم الهاتف يجب ان يبدا ب(09) ويليه ثمان ارقام ",
        },
      },
    });
    this.user = JSON.parse(localStorage.getItem("user"));
    this.token = localStorage.getItem("token");
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isAgreeKycUpdate();
          return;
        }
      });
    },
    updateBasicData() {
      this.disableFields = false;
      this.disableUpdateBtn = true;
    },
    alertBoxFunc() {
      this.alertBox = false;
    },
    isAgreeKycUpdate() {
      axios
        .post("/customer/updatekycbycustomer", this.requestInfoBasicData)
        .then((response) => {
          if (response.data.status === "success") {
            this.userDataActiveModal = false;
            this.alertBox = true;
          } else if (response.data.status === "fail") {
            console.log("fails");
          }
        })
        .catch((error) => {
          this.isLoading = !this.isLoading;
          this.message = true;
        });
    },
    validateBeforeSubmitKyc() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isAgreeKyc();
          return;
        }
      });
    },
    isAgreeKyc() {
      axios.get("/customer/acceptKyc/" + this.userData.id).then((response) => {
        // eslint-disable-next-line no-empty
        if (response.data.status === "success") {
          this.userDataActiveModal = false;
          this.alertBox = true;

          //window.location.reload();
          // console.log("hello");
          // this.services = response.data;
          // this.requestloading = false;
          // eslint-disable-next-line no-empty
        } else if (response.data.status === "fail") {
        }
      });
    },
    checkAgreeTerms(serviceName, routerName) {
      this.termName = serviceName;
      this.termRouterName = routerName;
      if (serviceName === "ZAD") {
        if (!this.isAgreeOnZadTerms) {
          this.getAllTerms(serviceName);
        } else {
          this.services.results[1].status
            ? this.$router.push("/services/tejwal")
            : this.$router.push("/services/closed");
        }
      } else if (serviceName == "VISA") {
        if (!this.isAgreeOnVisaTerms) {
          this.getAllTerms(serviceName);
        } else {
          this.$router.push("/services/visa");
          // this.gotovisaportal();
        }
      } else if (serviceName == "WAHDAMOBILE") {
        if (!this.isAgreeOnWahdaMobileTerms) {
          this.getAllTerms(serviceName);
        } else {
          if (routerName == "mobile") {
            this.services.results[5].status
              ? this.$router.push("/services/mobile")
              : this.$router.push("/services/closed");
          } else if (routerName == "mobicash") {
            this.services.results[5].status
              ? this.$router.push("/services/mobicash")
              : this.$router.push("/services/closed");
          }
        }
      }
    },
    getKycTerms() {
      axios
        .get("/kyc/terms")
        .then((response) => {
          if (response.data.status === "success") {
            this.terms = response.data.data;
          }
        })
        .catch((error) => {});
    },
    getAllTerms(serviceName) {
      axios
        .post("/services/terms/", null, {
          data: { termsOf: `${serviceName}` },
        })
        .then((response) => {
          this.popupStatus = !this.popupStatus;
          this.allTerms = response.data.result;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeTermsModal() {
      this.popupStatus = false;
    },
    agreeOnAllTerms() {
      axios
        .post("/admin/kyc/update/isAgreeOnTerms", {
          id: this.user[1],
          agreedOnService: this.termName,
        })
        .then((response) => {
          this.allTerms = null;
          if (this.termName == "ZAD") {
            this.isAgreeOnZadTerms = true;
          } else if (this.termName == "VISA") {
            this.isAgreeOnVisaTerms = true;
          } else if (this.termName == "WAHDAMOBILE") {
            this.isAgreeOnWahdaMobileTerms = true;
          }
          this.checkAgreeTerms(this.termName, this.termRouterName);
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },


    gotovisaportal() {
      window.location = "https://wo.ly/internal/login/" + this.token;
    },
  },
  mounted() {
    // eslint-disable-next-line no-undef

    var user = JSON.parse(localStorage.getItem("user"));

    axios
      .get("/customer/basicData/" + user[1])
      .then((response) => {
        this.$root.kick(response.data.message);
        this.info = response.data.result;

        // console.log('X X X X X X X X');

        // console.log(this.info.IsAgreeOnTerms);

        this.IsAgreeOnTerms = this.info.IsAgreeOnTerms;
        this.isAgreeOnZadTerms = this.info.IsAgreedOnZadTerms;
        this.isAgreeOnVisaTerms = this.info.IsAgreedOnVisaTerms;
        this.isAgreeOnWahdaMobileTerms = this.info.IsAgreedOnWahdaMobileTerms;

        if (this.IsAgreeOnTerms === false || this.IsAgreeOnTerms === 0) {
          this.$router.push('/terms');
        }

        // console.log('X X X X X X X X');
      })
      .catch((error) => {
        // this.$router.push('/');
      });

    axios.get("/Services").then((response) => {
      console.log(response.data);

      // eslint-disable-next-line no-empty
      if (response.data.status === "success") {
        this.services = response.data;
        this.requestloading = false;

        // eslint-disable-next-line no-empty
      } else if (response.data.status === "fail") {
      }
    });

    axios
      .get("/customer/basicData/" + user[1])
      .then((response) => {
        this.userData = response.data.result;

        this.requestInfoBasicData = {
          id: this.userData.id,
          firstName: this.userData.FirstName,
          fatherName: this.userData.FatherName,
          grandFatherName: this.userData.GrandFatherName,
          familyName: this.userData.FamilyName,
          passportNo: this.userData.PassportNO,
          nid: this.userData.NID,
          // DOB: this.userData.DOB,
          nidMobileNo: this.userData.NidMobileNo,
          passportExpirationDate: this.userData.PassportDateOfExpiration,
        };
        this.userDataActiveModal = true;
      })
      .catch((error) => {
        // this.$router.push('/');
      });


  },
};
</script>
